import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

import {
  ExtendedBox,
  Box,
  ExtendedFlex,
  Heading,
  Body,
  Theme,
} from '../../../coreui';

import FadeIn from '../../../components/FadeIn';
import backgroundImage from '../../../assets/IDP_process.jpg';

const StrategyRight = ({
  header,
  content,
}) => {
  return (
    <ExtendedBox
      width={[1, 1, 0.5, 0.5, 0.5]}
      minHeight={[null, null, 950, 1000, 950]}
    >
      <ExtendedBox
        height="100%"
        w={1}
        bgRepeat="no-repeat"
        bgImage={backgroundImage}
        bgPosition="50% 26%"
        bgSize="cover"
      >
        <Box
          w={1}
          px={['15%', '25%', '10%', '10%', '10%']}
        >
          <ExtendedFlex
            flexDirection="column"
            align={['center', 'center', 'flex-start', 'flex-start', 'flex-start']}
          >
            <ExtendedFlex
              maxWidth={['100%', '100%', 400, 400, 540]}
              flexDirection="column"
              my={[60, 60, 100, 100, 100]}
            >
              <FadeIn>
                <Heading
                  type="H2"
                  color="white"
                  m={0}
                  mb="1em"
                  opacity={1}
                  transition={`opacity ${Theme.fadeInDelay}ms 0.3s linear`}
                >
                  {header}
                </Heading>
                <Body
                  type="B1"
                  color="white"
                  opacity={1}
                  transition={`opacity ${Theme.fadeInDelay}ms 0.3s linear`}
                >
                  {ReactHtmlParser(content)}
                </Body>
              </FadeIn>
            </ExtendedFlex>
          </ExtendedFlex>
        </Box>
      </ExtendedBox>
    </ExtendedBox>
  );
};

StrategyRight.propTypes = {
  header: PropTypes.string,
  content: PropTypes.string,
};

export default StrategyRight;
